// extracted by mini-css-extract-plugin
export default {"BlankIcon":"_BlankIcon--w7lvS","CustomLabel":"_CustomLabel--M9XGK"};